import { categories, type Category, type Post } from "@/mocks/content";

export function getCat(id: string): Category {
  return categories.find((c) => c.id === id) ?? categories[0];
}

/** solid badge over image */
export function badgeOnImage(id: string): string {
  switch (id) {
    case "prophet":
      return "bg-accent-500";
    case "back":
      return "bg-secondary-500";
    default:
      return "bg-primary-500";
  }
}

/** light badge (tint) */
export function badgeTint(id: string): string {
  switch (id) {
    case "prophet":
      return "bg-accent-100 text-accent-700";
    case "back":
      return "bg-secondary-100 text-secondary-800";
    default:
      return "bg-primary-100 text-primary-700";
  }
}

export function textAccent(id: string): string {
  switch (id) {
    case "prophet":
      return "text-accent-600";
    case "back":
      return "text-secondary-600";
    default:
      return "text-primary-600";
  }
}

export function catOf(post: Post): Category {
  return getCat(post.cat);
}